import React, { Component } from "react";
import { Accordion } from "react-bootstrap";
import _ from "lodash";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { navigate } from "gatsby";
const closeIcon = "https://s3.amazonaws.com/media-dev.salvex.com/static/images/close-icon.svg";

const conditionOptions = [
  "New",
  "New Surplus",
  "Used",
  "Damaged",
  "Scrap",
  "Factory New",
  "Overhauled",
  "Serviceable",
  "As Removed",
  "Repairable",
  "Repaired",
  "Inspected",
  "Core",
  "Beyond Economical Repair",
  "Rebuilt",
  "Modified",
  "Tested",
  "Unserviceable",
  "Disposal",
  "Disposal/Free",
];

class FilterSidebar extends Component {
  state = { filtersShow: 6, defaultActiveKey: ["0", "1", "2", "3", "4", "5", "6", "7"], showAllType: "" };
  handleToggle = (id) => {
    const { defaultActiveKey } = this.state;
    const findId = defaultActiveKey.find((key) => key === id);
    if (findId) {
      this.setState({
        defaultActiveKey: defaultActiveKey.filter((key) => key !== id),
      });
    } else {
      const newData = [...defaultActiveKey, ...[id]];
      this.setState({ defaultActiveKey: newData });
    }
  };
  showMore = (counts, data, type) => {
    this.props.filterModalDataCounts(counts);
    this.props.filterModalData(data);
    this.props.toggleFilter();
    this.props.modalType(type);
  };
  render() {
    const {
      catagory,
      catagory1,
      catagory2,
      conditionType,
      make,
      model,
      region,
      region1,
      removeFilter,
      loadingMain,
      path,
    } = this.props;
    const aviationModelData = this.props?.aviationModel;
    const { facets } = this.props;

    const cat =
      catagory?.length === 0 && (path === "/search/" || path === "/listings/index.cfm/catid/1001/")
        ? facets["push_categories"] && Object.keys(facets["push_categories"])?.filter((hd) => !hd?.includes(">"))
        : [];
    const subCat =
      facets["push_categories"] &&
      Object.keys(facets["push_categories"])?.filter((hd) => (hd.match(/>/g) || []).length === 1);
    const subCatLevel2 =
      facets["push_categories"] &&
      Object.keys(facets["push_categories"])?.filter((hd) => (hd.match(/>/g) || []).length === 2);
    const aviationModel =
      (facets["aviation_model_name"] &&
        Object.entries(facets["aviation_model_name"]).sort(function (a, b) {
          var textA = facets["aviation_model_name"][a];
          var textB = facets["aviation_model_name"][b];
          return textB - textA;
        })) ||
      [];

    const condition =
      (facets["conditionType"] &&
        Object.entries(facets["conditionType"])
          .sort(function (a, b) {
            var textA = facets["conditionType"][a];
            var textB = facets["conditionType"][b];
            return textB - textA;
          })
          .filter(
            (item) => conditionOptions?.includes(item[0]?.split("-")?.[1]) || conditionOptions?.includes(item[0]),
          )) ||
      [];

    const makefilter =
      facets["make"] &&
      Object.keys(facets["make"]).sort(function (a, b) {
        var textA = facets["make"][a];
        var textB = facets["make"][b];
        return textB - textA;
      });
    const modelfilter =
      facets["model"] &&
      Object.keys(facets["model"]).sort(function (a, b) {
        var textA = facets["model"][a];
        var textB = facets["model"][b];
        return textB - textA;
      });
    const regionfilter =
      facets["regions.lvl0"] &&
      Object.keys(facets["regions.lvl0"]).sort(function (a, b) {
        var textA = facets["regions.lvl0"][a];
        var textB = facets["regions.lvl0"][b];
        return textB - textA;
      });
    const subRegionfilter =
      facets["regions.lvl1"] &&
      Object.keys(facets["regions.lvl1"])
        ?.filter((iy) => iy != "United States")
        ?.sort(function (a, b) {
          var textA = facets["regions.lvl1"][a];
          var textB = facets["regions.lvl1"][b];
          return textB - textA;
        });
    const activeFilters = [
      ...catagory,
      ...catagory1,
      ...catagory2,
      ...aviationModelData,
      ...conditionType,
      ...make,
      ...model,
      ...region,
      ...region1,
    ];
    const showFilters = _.take(activeFilters, this.state.filtersShow);

    return (
      <div className="fc-sidebar d-none d-lg-block">
        <div className="fc-sidebar-inner fc-sidebar-inner-unset">
          {activeFilters.length !== 0 && (
            <div className="filter-tags-container filter-tag-new">
              <div className="ftc-head d-flex align-items-center justify-content-between">
                {loadingMain ? (
                  <Skeleton height={20} width={290} />
                ) : (
                  <>
                    <h4>Filters</h4>
                    <button
                      type="button"
                      className="clear-filter-text"
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.clearFilter("all");
                      }}
                    >
                      Clear filters
                    </button>
                  </>
                )}
              </div>
              {loadingMain ? (
                <Skeleton height={20} width={290} />
              ) : (
                ((catagory && catagory.length > 0) ||
                  (catagory1 && catagory1.length > 0) ||
                  (catagory2 && catagory2.length > 0) ||
                  (aviationModelData && aviationModelData.length > 0) ||
                  (conditionType && conditionType.length > 0) ||
                  (make && make.length > 0) ||
                  (model && model.length > 0) ||
                  (region && region.length > 0) ||
                  (region1 && region1.length > 0)) && (
                  <div className="filter-tags">
                    <div className="tags">
                      {catagory.map((f, i) =>
                        f.includes("_") ? (
                          <span className="badge">
                            {f.split("_")[0]}
                            <img
                              className="tag-close-icon"
                              src={closeIcon}
                              alt="close"
                              onClick={(e) => {
                                removeFilter(i, "catagory");
                              }}
                            />
                          </span>
                        ) : (
                          ""
                        ),
                      )}
                      {catagory1.map((f, i) =>
                        f?.includes("_") ? (
                          <span className="badge">
                            {f.substr(f.indexOf(">") + 1).split("_")[0]}
                            <img
                              className="tag-close-icon"
                              src={closeIcon}
                              alt="close"
                              onClick={(e) => {
                                removeFilter(i, "catagory1");
                              }}
                            />
                          </span>
                        ) : (
                          ""
                        ),
                      )}{" "}
                      {catagory2.map((f, i) => (
                        <span className="badge">
                          {f.split(">")[2]?.split("_")[0]}
                          <img
                            className="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "catagory2");
                            }}
                          />
                        </span>
                      ))}{" "}
                      {aviationModelData.map((f, i) => (
                        <span className="badge">
                          {f?.split("_")[0]}
                          <img
                            className="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "aviationModel");
                            }}
                          />
                        </span>
                      ))}{" "}
                      {conditionType.map((f, i) => (
                        <span className="badge">
                          {f}
                          <img
                            className="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "conditionType");
                            }}
                          />
                        </span>
                      ))}{" "}
                      {make.map((f, i) => (
                        <span className="badge">
                          {f}
                          <img
                            className="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "make");
                            }}
                          />
                        </span>
                      ))}{" "}
                      {model.map((f, i) => (
                        <span className="badge">
                          {f}
                          <img
                            className="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "model");
                            }}
                          />
                        </span>
                      ))}{" "}
                      {region.map((f, i) => (
                        <span className="badge">
                          {f}
                          <img
                            className="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "region");
                            }}
                          />
                        </span>
                      ))}
                      {region1.map((f, i) => (
                        <span className="badge">
                          {f}
                          <img
                            className="tag-close-icon"
                            src={closeIcon}
                            alt="close"
                            onClick={(e) => {
                              removeFilter(i, "region1");
                            }}
                          />
                        </span>
                      ))}
                    </div>
                  </div>
                )
              )}
            </div>
          )}
          {loadingMain ? (
            <Accordion activeKey={this.state.defaultActiveKey} className="accordion add-custom-icons">
              {" "}
              <Accordion.Item eventKey="0">
                <div className="d-flex align-items-center justify-content-center mt-3 mb-3">
                  <Skeleton height={20} width={290} />
                </div>

                <Accordion.Body>
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
                    <div className="form-check d-flex align-items-center" style={{ paddingLeft: "0" }}>
                      <Skeleton height={20} width={290} />
                    </div>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <div className="d-flex align-items-center justify-content-center mt-3 mb-3">
                  <Skeleton height={20} width={290} />
                </div>

                <Accordion.Body>
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
                    <div className="form-check d-flex align-items-center" style={{ paddingLeft: "0" }}>
                      <Skeleton height={20} width={290} />
                    </div>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <div className="d-flex align-items-center justify-content-center mt-3 mb-3">
                  <Skeleton height={20} width={290} />
                </div>

                <Accordion.Body>
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
                    <div className="form-check d-flex align-items-center" style={{ paddingLeft: "0" }}>
                      <Skeleton height={20} width={290} />
                    </div>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ) : (
            <Accordion activeKey={this.state.defaultActiveKey} className="accordion add-custom-icons">
              {cat && cat.length > 0 && (
                <Accordion.Item eventKey="0">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("0");
                    }}
                  >
                    Category
                  </Accordion.Header>

                  <Accordion.Body key={catagory.length}>
                    {catagory.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        className="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("catagory");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {this.state.showAllType == "cat"
                      ? cat
                          .sort((a, b) => a.localeCompare(b))
                          .map((v) =>
                            v?.includes("_") ? (
                              <div className="form-check d-flex align-items-center">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id={v}
                                  checked={cat?.length == 1 ? true : catagory.find((ev) => ev === v) ? true : false}
                                />
                                <label
                                  className="form-check-label"
                                  for={v}
                                  onClick={() => {
                                    if (cat?.length == 1) {
                                      navigate("/listings/index.cfm/catid/1001/?page=1");
                                    } else {
                                      this.props.setData("catagory", v);
                                    }
                                  }}
                                >
                                  {`${v.split("_")[0]} (${facets["push_categories"][v]})`}
                                </label>
                              </div>
                            ) : (
                              ""
                            ),
                          )
                      : cat
                          .sort((a, b) => a.localeCompare(b))
                          ?.slice(0, 16)
                          .map((v) =>
                            v.includes("_") ? (
                              <div className="form-check d-flex align-items-center">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id={v}
                                  checked={cat?.length == 1 ? true : catagory.find((ev) => ev === v) ? true : false}
                                />
                                <label
                                  className="form-check-label"
                                  for={v}
                                  onClick={() => {
                                    if (cat?.length == 1) {
                                      navigate("/listings/index.cfm/catid/1001/?page=1");
                                    } else {
                                      this.props.setData("catagory", v);
                                    }
                                  }}
                                >
                                  {`${v.split("_")[0]} (${facets["push_categories"][v]})`}
                                </label>
                              </div>
                            ) : (
                              ""
                            ),
                          )}
                    {facets["categories.lvl0"] &&
                      Object.keys(facets["categories.lvl0"]) &&
                      Object.keys(facets["categories.lvl0"]).length > 16 && (
                        <a
                          href="javascript:void(0)"
                          className="showmore-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#subCatModal"
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.showAllType != "cat") {
                              this.setState({ showAllType: "cat" });
                            } else {
                              this.setState({ showAllType: "" });
                            }
                          }}
                        >
                          {this.state.showAllType == "cat" ? "Show less" : "Show more"}
                        </a>
                      )}
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {subCat && subCat.length > 0 && (
                <Accordion.Item eventKey="1">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("1");
                    }}
                  >
                    Sub Category
                  </Accordion.Header>
                  <Accordion.Body key={catagory1.length}>
                    {catagory1.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        className="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("catagory1");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {this.state.showAllType == "subCat" ? (
                      subCat
                        ?.sort((a, b) => a.localeCompare(b))
                        ?.map((v) =>
                          v?.includes("_") ? (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={
                                  catagory1.find(
                                    (ev) => ev.substr(ev.indexOf(">") + 1) === v.substr(v.indexOf(">") + 1),
                                  )
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label"
                                for={v}
                                onClick={() => {
                                  this.props.setData("catagory1", v);
                                }}
                              >
                                {`${v.substr(v.indexOf(">") + 1).split("_")[0]} (${facets["push_categories"][v]})`}
                              </label>
                            </div>
                          ) : (
                            ""
                          ),
                        )
                    ) : (cat?.length == 1 && cat[0] == "Aviation_1176") ||
                      this.props?.mainCategory?.category?.category_id == 1176 ? (
                      <div class="content-radio-group">
                        {subCat
                          .sort((a, b) => a.localeCompare(b))
                          ?.slice(0, 16)
                          ?.map((v) => (
                            <div class="form-check radio ">
                              <input
                                class="form-check-input cursor-pointer"
                                type="radio"
                                name="contentRadio"
                                id={v}
                                checked={
                                  catagory1.find(
                                    (ev) => ev.substr(ev.indexOf(">") + 1) === v.substr(v.indexOf(">") + 1),
                                  )
                                    ? true
                                    : false
                                }
                                onChange={() => {
                                  this.props.setData("catagory1", v);
                                }}
                              />
                              <label class="form-check-label cursor-pointer" for={v}>
                                {`${v.substr(v.indexOf(">") + 1).split("_")[0]} (${facets["push_categories"][v]})`}
                              </label>
                            </div>
                          ))}
                      </div>
                    ) : (
                      subCat
                        .sort((a, b) => a.localeCompare(b))
                        ?.slice(0, 16)
                        ?.map((v) =>
                          v?.includes("_") ? (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={
                                  catagory1.find(
                                    (ev) => ev.substr(ev.indexOf(">") + 1) === v.substr(v.indexOf(">") + 1),
                                  )
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label"
                                for={v}
                                onClick={() => this.props.setData("catagory1", v)}
                              >
                                {`${v.substr(v.indexOf(">") + 1).split("_")[0]} (${facets["push_categories"][v]})`}
                              </label>
                            </div>
                          ) : (
                            ""
                          ),
                        )
                    )}
                    {facets["categories.lvl1"] &&
                      Object.keys(facets["categories.lvl1"]) &&
                      Object.keys(facets["categories.lvl1"]).length > 16 && (
                        <a
                          href="javascript:void(0)"
                          className="showmore-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#subCatModal"
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.showAllType != "subCat") {
                              this.setState({ showAllType: "subCat" });
                            } else {
                              this.setState({ showAllType: "" });
                            }
                          }}
                        >
                          {this.state.showAllType == "subCat" ? "Show Less" : "Show More"}
                        </a>
                      )}
                  </Accordion.Body>
                </Accordion.Item>
              )}
              {subCatLevel2 && subCatLevel2.length > 0 && (
                <Accordion.Item eventKey="5">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("5");
                    }}
                  >
                    Part Type
                  </Accordion.Header>
                  <Accordion.Body key={catagory2.length}>
                    {catagory1.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        className="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("catagory2");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {this.state.showAllType == "subCatLevel2"
                      ? subCatLevel2
                          .sort((a, b) => b[1] - a[1])
                          ?.map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v[0]}
                                checked={
                                  catagory2.find(
                                    (ev) => ev.substr(ev.lastIndexOf(">") + 1) === v.substr(v.lastIndexOf(">") + 1),
                                  )
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label"
                                for={v}
                                onClick={() => this.props.setData("catagory2", v)}
                              >
                                {`${v.substr(v.lastIndexOf(">") + 1).split("_")[0]} (${facets["push_categories"][v]})`}
                              </label>
                            </div>
                          ))
                      : subCatLevel2
                          .sort((a, b) => b[1] - a[1])
                          ?.slice(0, 16)
                          ?.map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v[0]}
                                checked={
                                  catagory2.find(
                                    (ev) => ev.substr(ev.lastIndexOf(">") + 1) === v.substr(v.lastIndexOf(">") + 1),
                                  )
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label"
                                for={v[0]}
                                onClick={() => this.props.setData("catagory2", v)}
                              >
                                {`${v.substr(v.lastIndexOf(">") + 1).split("_")[0]} (${facets["push_categories"][v]})`}
                              </label>
                            </div>
                          ))}
                    {facets["categories.lvl2"] &&
                      Object.keys(facets["categories.lvl2"]) &&
                      Object.keys(facets["categories.lvl2"]).length > 16 && (
                        <a
                          href="javascript:void(0)"
                          className="showmore-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#subCatModal"
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.showAllType != "subCatLevel2") {
                              this.setState({ showAllType: "subCatLevel2" });
                            } else {
                              this.setState({ showAllType: "" });
                            }
                          }}
                        >
                          {this.state.showAllType == "subCatLevel2" ? "Show Less" : "Show More"}
                        </a>
                      )}
                  </Accordion.Body>
                </Accordion.Item>
              )}
              {aviationModel && aviationModel.length > 0 && (
                <Accordion.Item eventKey="6">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("6");
                    }}
                  >
                    Plane Model
                  </Accordion.Header>
                  <Accordion.Body key={aviationModelData.length}>
                    {aviationModelData.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        className="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("aviationModel");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {this.state.showAllType == "aviationModel"
                      ? aviationModel
                          ?.sort((a, b) => b[1] - a[1])
                          ?.map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v[0]}
                                checked={
                                  aviationModelData.find(
                                    (ev) =>
                                      ev.substr(ev.lastIndexOf(">") + 1) === v[0].substr(v[0].lastIndexOf(">") + 1),
                                  )
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label"
                                for={v[0]}
                                onClick={() => this.props.setData("aviationModel", v[0])}
                              >
                                {`${v[0].substr(v[0].lastIndexOf(">") + 1).split("_")[0]} (${
                                  facets["aviation_model_name"][v[0]]
                                })`}
                              </label>
                            </div>
                          ))
                      : aviationModel
                          .sort((a, b) => b[1] - a[1])
                          ?.slice(0, 16)
                          ?.map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v[0]}
                                checked={
                                  aviationModelData.find(
                                    (ev) =>
                                      ev.substr(ev.lastIndexOf(">") + 1) === v[0].substr(v[0].lastIndexOf(">") + 1),
                                  )
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label"
                                for={v[0]}
                                onClick={() => this.props.setData("aviationModel", v[0])}
                              >
                                {`${v[0].substr(v[0].lastIndexOf(">") + 1).split("_")[0]} (${
                                  facets["aviation_model_name"][v[0]]
                                })`}
                              </label>
                            </div>
                          ))}
                    {facets["aviation_model_name"] &&
                      Object.keys(facets["aviation_model_name"]) &&
                      Object.keys(facets["aviation_model_name"]).length > 16 && (
                        <a
                          href="javascript:void(0)"
                          className="showmore-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#subCatModal"
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.showAllType != "aviationModel") {
                              this.setState({ showAllType: "aviationModel" });
                            } else {
                              this.setState({ showAllType: "" });
                            }
                          }}
                        >
                          {this.state.showAllType == "aviationModel" ? "Show Less" : "Show More"}
                        </a>
                      )}
                  </Accordion.Body>
                </Accordion.Item>
              )}
              {condition && condition.length > 0 && (
                <Accordion.Item eventKey="7">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("7");
                    }}
                  >
                    Condition
                  </Accordion.Header>
                  <Accordion.Body key={conditionType.length}>
                    {conditionType.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        className="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("conditionType");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {this.state.showAllType == "conditionType"
                      ? condition
                          ?.sort((a, b) => b[1] - a[1])
                          ?.map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v[0]}
                                checked={conditionType.find((ev) => ev === v[0]) ? true : false}
                              />
                              <label
                                className="form-check-label"
                                for={v[0]}
                                onClick={() => this.props.setData("conditionType", v[0])}
                              >
                                {`${v[0]} (${v[1]})`}
                              </label>
                            </div>
                          ))
                      : condition
                          .sort((a, b) => b[1] - a[1])
                          ?.slice(0, 16)
                          ?.map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v[0]}
                                checked={conditionType.find((ev) => ev === v[0]) ? true : false}
                              />
                              <label
                                className="form-check-label"
                                for={v[0]}
                                onClick={() => this.props.setData("conditionType", v[0])}
                              >
                                {`${v[0]} (${v[1]})`}
                              </label>
                            </div>
                          ))}
                    {facets["conditionType"] &&
                      Object.keys(facets["conditionType"]) &&
                      Object.keys(facets["conditionType"]).length > 16 && (
                        <a
                          href="javascript:void(0)"
                          className="showmore-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#subCatModal"
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.showAllType != "conditionType") {
                              this.setState({ showAllType: "conditionType" });
                            } else {
                              this.setState({ showAllType: "" });
                            }
                          }}
                        >
                          {this.state.showAllType == "conditionType" ? "Show Less" : "Show More"}
                        </a>
                      )}
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {makefilter && makefilter.length > 0 && (
                <Accordion.Item eventKey="2">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("2");
                    }}
                  >
                    Manufacturer
                  </Accordion.Header>
                  <Accordion.Body>
                    {make.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        className="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("make");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {this.state.showAllType == "makefilter"
                      ? makefilter
                          .sort((a, b) => a.localeCompare(b))
                          .map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={make.find((ev) => ev === v) ? true : false}
                              />
                              <label className="form-check-label" for={v} onClick={() => this.props.setData("make", v)}>
                                {`${v} (${facets["make"][v]})`}
                              </label>
                            </div>
                          ))
                      : makefilter
                          .sort((a, b) => a.localeCompare(b))
                          ?.slice(0, 16)
                          .map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={make.find((ev) => ev === v) ? true : false}
                              />
                              <label className="form-check-label" for={v} onClick={() => this.props.setData("make", v)}>
                                {`${v} (${facets["make"][v]})`}
                              </label>
                            </div>
                          ))}
                    {facets["make"] && Object.keys(facets["make"]) && Object.keys(facets["make"]).length > 16 && (
                      <a
                        href="javascript:void(0)"
                        className="showmore-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#subCatModal"
                        onClick={(e) => {
                          e.preventDefault();
                          if (this.state.showAllType != "makefilter") {
                            this.setState({ showAllType: "makefilter" });
                          } else {
                            this.setState({ showAllType: "" });
                          }
                        }}
                      >
                        {this.state.showAllType == "makefilter" ? "Show less" : "Show more"}
                      </a>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {/* {modelfilter && modelfilter.length > 0 && (
                <Accordion.Item eventKey="3">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("3");
                    }}
                  >
                    Model
                  </Accordion.Header>
                  <Accordion.Body>
                    {model.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        className="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("model");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {modelfilter
                      .sort((a, b) => facets["model"][b] - facets["model"][a])
                      .map((v) => (
                        <div className="form-check d-flex align-items-center">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id={v}
                            checked={model.find((ev) => ev === v) ? true : false}
                          />
                          <label className="form-check-label" for={v} onClick={() => this.props.setData("model", v)}>
                            {`${v} (${facets["model"][v]})`}
                          </label>
                        </div>
                      ))}
                    {facets["model"] && Object.keys(facets["model"]) && Object.keys(facets["model"]).length > 6 && (
                      <a
                        href="javascript:void(0)"
                        className="showmore-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#subCatModal"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showMore(facets["model"], Object.keys(facets["model"]), "model");
                        }}
                      >
                        Show more
                      </a>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              )} */}

              {regionfilter && regionfilter.length > 0 && (
                <Accordion.Item eventKey="4">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("4");
                    }}
                  >
                    Region
                  </Accordion.Header>
                  <Accordion.Body>
                    {region.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        className="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("region");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {this.state.showAllType == "regionfilter"
                      ? regionfilter
                          .sort((a, b) => a.localeCompare(b))
                          .map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={region.find((ev) => ev === v) ? true : false}
                              />

                              <label
                                className="form-check-label"
                                for={v}
                                onClick={() => this.props.setData("region", v)}
                              >
                                {`${v == "North America" ? "United States" : v} (${facets["regions.lvl0"][v]})`}
                              </label>
                            </div>
                          ))
                      : regionfilter
                          .sort((a, b) => a.localeCompare(b))
                          ?.slice(0, 16)
                          .map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={region.find((ev) => ev === v) ? true : false}
                              />
                              <label
                                className="form-check-label"
                                for={v}
                                onClick={() => this.props.setData("region", v)}
                              >
                                {`${v} (${facets["regions.lvl0"][v]})`}
                              </label>
                            </div>
                          ))}
                    {facets["regions.lvl0"] &&
                      Object.keys(facets["regions.lvl0"]) &&
                      Object.keys(facets["regions.lvl0"]).length > 16 && (
                        <a
                          href="javascript:void(0)"
                          className="showmore-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#subCatModal"
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.showAllType != "regionfilter") {
                              this.setState({ showAllType: "regionfilter" });
                            } else {
                              this.setState({ showAllType: "" });
                            }
                          }}
                        >
                          {this.state.showAllType == "regionfilter" ? "Show less" : "Show more"}
                        </a>
                      )}
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {subRegionfilter && subRegionfilter.length > 0 && (
                <Accordion.Item eventKey="4">
                  <Accordion.Header
                    onClick={(e) => {
                      this.handleToggle("4");
                    }}
                  >
                    Sub Region
                  </Accordion.Header>
                  <Accordion.Body>
                    {region.length > 0 && (
                      <a
                        href="javascript:void(0)"
                        className="clearall-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.clearFilter("region1");
                        }}
                      >
                        Clear all
                      </a>
                    )}
                    {this.state.showAllType == "subRegionfilter"
                      ? subRegionfilter
                          .sort((a, b) => a.localeCompare(b))
                          .map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={region1.find((ev) => ev === v) ? true : false}
                              />
                              <label
                                className="form-check-label"
                                for={v}
                                onClick={() => this.props.setData("region1", v)}
                              >
                                {`${v?.includes(">") ? v?.split(">")?.[1] : v} (${facets["regions.lvl1"][v]})`}
                              </label>
                            </div>
                          ))
                      : subRegionfilter
                          .sort((a, b) => a.localeCompare(b))
                          ?.slice(0, 16)
                          .map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={region1.find((ev) => ev === v) ? true : false}
                              />
                              <label
                                className="form-check-label"
                                for={v}
                                onClick={() => this.props.setData("region1", v)}
                              >
                                {`${v?.includes(">") ? v?.split(">")?.[1] : v} (${facets["regions.lvl1"][v]})`}
                              </label>
                            </div>
                          ))}
                    {facets["regions.lvl1"] &&
                      Object.keys(facets["regions.lvl1"]) &&
                      Object.keys(facets["regions.lvl1"]).length > 16 && (
                        <a
                          href="javascript:void(0)"
                          className="showmore-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#subCatModal"
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.showAllType != "subRegionfilter") {
                              this.setState({ showAllType: "subRegionfilter" });
                            } else {
                              this.setState({ showAllType: "" });
                            }
                          }}
                        >
                          {this.state.showAllType == "subRegionfilter" ? "Show less" : "Show more"}
                        </a>
                      )}
                  </Accordion.Body>
                </Accordion.Item>
              )}
            </Accordion>
          )}
        </div>
      </div>
    );
  }
}

export default FilterSidebar;
